module.exports = __webpack_public_path__ + "img/outlaw-brewing-dark-horse-stout.9cf8bcc9.png";